import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";

import "./story-card.m.css";

const PortraitStoryCard = ({ story, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName="card">
        <HeroImage story={story} aspectRatio={[[9, 16]]} iconSizes={{ height: 24, width: 24 }} />
        {label && <Label story={story} />}

        {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}
      </div>
    </Link>
  );
};

PortraitStoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  sectionSlug: PropTypes.string,
};

export default PortraitStoryCard;
